export const pageConfig = {
  service_agreement: {
    query: '服务协议',
    pageTitle: '面试虫服务协议'
  },
  privacy_policy: {
    query: '隐私政策',
    pageTitle: '面试虫隐私政策'
  },
  personal_info_collection_list: {
    query: '个人信息收集清单',
    pageTitle: '个人信息收集清单'
  },
  third_party_info_sharing_list: {
    query: '第三方信息共享清单',
    pageTitle: '第三方信息共享清单'
  }
};
